<template>
    <v-container fluid class="pa-4">
        <v-tabs v-model="tab" background-color="transparent" slider-color="primary" class="mb-2">
            <v-tab>Istanze</v-tab>
            <v-tab>Template</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <!-- Istanze -->
            <v-tab-item>
                <v-card>
                    <v-card-title class="text-h6">
                        <v-icon left color="primary">mdi-human-greeting</v-icon>
                        Onboarding / Offboarding
                        <v-spacer></v-spacer>
                        <v-btn color="primary" small @click="openStartDialog">
                            <v-icon left small>mdi-play</v-icon>Avvia da template
                        </v-btn>
                        <v-btn icon class="ml-2" @click="load" :loading="loading"><v-icon>mdi-refresh</v-icon></v-btn>
                    </v-card-title>

                    <v-data-table :headers="headers" :items="items" :loading="loading" :items-per-page="25">
                        <template v-slot:item.kind="{ item }">
                            <v-chip small :color="item.kind === 'onboarding' ? 'green' : 'red'" text-color="white">
                                {{ item.kind === 'onboarding' ? 'Onboarding' : 'Offboarding' }}
                            </v-chip>
                        </template>
                        <template v-slot:item.trigger_date="{ item }">{{ formatDate(item.trigger_date) }}</template>
                        <template v-slot:item.status="{ item }">
                            <v-chip small :color="statusColor(item.status)" text-color="white">{{ statusText(item.status) }}</v-chip>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn icon small @click="openDetail(item)"><v-icon small>mdi-eye</v-icon></v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-tab-item>

            <!-- Template -->
            <v-tab-item>
                <v-card>
                    <v-card-title class="text-h6">
                        <v-icon left color="primary">mdi-file-tree</v-icon>
                        Template
                        <v-spacer></v-spacer>
                        <v-btn color="primary" small @click="openTemplateDialog">
                            <v-icon left small>mdi-plus</v-icon>Nuovo template
                        </v-btn>
                    </v-card-title>
                    <v-data-table :headers="templateHeaders" :items="templates" :items-per-page="25">
                        <template v-slot:item.kind="{ item }">
                            <v-chip small :color="item.kind === 'onboarding' ? 'green' : 'red'" text-color="white">{{ item.kind }}</v-chip>
                        </template>
                        <template v-slot:item.tasks_count="{ item }">{{ (item.tasks || []).length }}</template>
                    </v-data-table>
                </v-card>
            </v-tab-item>
        </v-tabs-items>

        <!-- Dialog avvia onboarding -->
        <v-dialog v-model="startDialog" max-width="500">
            <v-card>
                <v-card-title><v-icon left color="primary">mdi-play</v-icon>Avvia onboarding</v-card-title>
                <v-card-text>
                    <v-autocomplete v-model="startForm.employee_id" :items="employees" item-text="text" item-value="value" label="Dipendente" prepend-icon="mdi-account-tie" outlined dense></v-autocomplete>
                    <v-autocomplete v-model="startForm.template_id" :items="templates.map(t=>({value:t.id,text:t.name+' · '+t.kind}))" item-text="text" item-value="value" label="Template" prepend-icon="mdi-file-tree" outlined dense></v-autocomplete>
                    <gmh-date-picker v-model="startForm.trigger_date" label="Data avvio" prepend-icon="mdi-calendar-start" editable></gmh-date-picker>
                    <v-select v-model="startForm.kind" :items="[{value:'onboarding',text:'Onboarding'},{value:'offboarding',text:'Offboarding'}]" label="Tipo" prepend-icon="mdi-swap-horizontal" outlined dense></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="startDialog = false">Annulla</v-btn>
                    <v-btn color="primary" @click="start">Avvia</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog nuovo template -->
        <v-dialog v-model="templateDialog" max-width="800">
            <v-card>
                <v-card-title><v-icon left color="primary">mdi-file-tree</v-icon>Nuovo template</v-card-title>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" md="8">
                            <v-text-field v-model="templateForm.name" label="Nome" prepend-icon="mdi-label" outlined dense></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="templateForm.kind" :items="[{value:'onboarding',text:'Onboarding'},{value:'offboarding',text:'Offboarding'}]" label="Tipo" prepend-icon="mdi-swap-horizontal" outlined dense></v-select>
                        </v-col>
                    </v-row>
                    <v-textarea v-model="templateForm.description" label="Descrizione" prepend-icon="mdi-text" outlined dense rows="2"></v-textarea>

                    <v-divider class="my-3"></v-divider>
                    <div class="d-flex align-center mb-2">
                        <div class="text-subtitle-2">Task</div>
                        <v-spacer></v-spacer>
                        <v-btn small text @click="addTask"><v-icon left small>mdi-plus</v-icon>Aggiungi task</v-btn>
                    </div>
                    <div v-for="(t, i) in templateForm.tasks" :key="i" class="mb-2">
                        <v-row dense>
                            <v-col cols="12" md="5">
                                <v-text-field v-model="t.title" label="Titolo" dense outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" md="3">
                                <v-select v-model="t.owner_role" :items="[{value:'hr',text:'HR'},{value:'it',text:'IT'},{value:'manager',text:'Manager'},{value:'employee',text:'Dipendente'}]" label="Responsabile" dense outlined hide-details></v-select>
                            </v-col>
                            <v-col cols="6" md="3">
                                <v-text-field v-model.number="t.due_days_from_trigger" type="number" label="Giorni dal trigger" dense outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" md="1" class="d-flex align-center">
                                <v-btn icon small color="error" @click="templateForm.tasks.splice(i,1)"><v-icon small>mdi-delete</v-icon></v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="templateDialog = false">Annulla</v-btn>
                    <v-btn color="primary" @click="saveTemplate">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog dettaglio con task board -->
        <v-dialog v-model="detailDialog" max-width="800">
            <v-card v-if="detail">
                <v-card-title>
                    <v-icon left color="primary">mdi-human-greeting</v-icon>
                    {{ detail.kind === 'onboarding' ? 'Onboarding' : 'Offboarding' }} — {{ detail.employee ? detail.employee.first_name + ' ' + detail.employee.last_name : '' }}
                </v-card-title>
                <v-card-text>
                    <div class="text-caption mb-2">Trigger: {{ formatDate(detail.trigger_date) }} · Stato: {{ statusText(detail.status) }}</div>
                    <v-simple-table dense>
                        <thead>
                            <tr><th>Task</th><th>Responsabile</th><th>Scadenza</th><th>Stato</th><th></th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="t in (detail.tasks || [])" :key="t.id">
                                <td>{{ t.title }}</td>
                                <td>{{ roleText(t.owner_role) }}</td>
                                <td>{{ formatDate(t.due_date) }}</td>
                                <td>
                                    <v-chip small :color="taskStatusColor(t.status)" text-color="white">{{ taskStatusText(t.status) }}</v-chip>
                                </td>
                                <td>
                                    <v-btn v-if="t.status !== 'done'" icon small color="success" @click="completeTask(t)" title="Completa">
                                        <v-icon small>mdi-check</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="detailDialog = false">Chiudi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { localDateStr } from '@/components/utilities/hrDates'
    export default {
        name: 'hr-onboardings',

        data() {
            return {
                tab: 0,
                items: [],
                templates: [],
                employees: [],
                loading: false,
                startDialog: false,
                startForm: { employee_id: null, template_id: null, trigger_date: localDateStr(), kind: 'onboarding' },
                templateDialog: false,
                templateForm: { name: '', kind: 'onboarding', description: '', tasks: [] },
                detailDialog: false,
                detail: null,
                headers: [
                    { text: 'Dipendente', value: 'employee_full_name' },
                    { text: 'Template', value: 'template_name' },
                    { text: 'Tipo', value: 'kind' },
                    { text: 'Data trigger', value: 'trigger_date' },
                    { text: 'Stato', value: 'status' },
                    { text: '', value: 'actions', sortable: false, align: 'end' },
                ],
                templateHeaders: [
                    { text: 'Nome', value: 'name' },
                    { text: 'Tipo', value: 'kind' },
                    { text: 'Task', value: 'tasks_count' },
                ],
            }
        },

        methods: {
            load() {
                this.loading = true
                this.axios.post('hronboardings-filters').then(r => { this.items = r.data.data || []; this.loading = false }, () => { this.loading = false })
                this.axios.get('hronboardingtemplates').then(r => { this.templates = r.data.data || [] })
                this.axios.post('hremployees-filters').then(r => {
                    const data = r.data.data && r.data.data.data ? r.data.data.data : (Array.isArray(r.data.data) ? r.data.data : [])
                    this.employees = data.map(e => ({ value: e.id, text: `${e.first_name || ''} ${e.last_name || ''}`.trim() || `#${e.id}` }))
                })
            },
            openStartDialog() { this.startForm = { employee_id: null, template_id: null, trigger_date: localDateStr(), kind: 'onboarding' }; this.startDialog = true },
            start() {
                this.axios.post('hronboardings-start', this.startForm).then(() => { this.startDialog = false; this.load() })
            },
            openTemplateDialog() { this.templateForm = { name: '', kind: 'onboarding', description: '', tasks: [] }; this.templateDialog = true },
            addTask() { this.templateForm.tasks.push({ title: '', owner_role: 'hr', due_days_from_trigger: 0 }) },
            saveTemplate() {
                this.axios.post('hronboardingtemplates', this.templateForm).then(() => { this.templateDialog = false; this.load() })
            },
            openDetail(item) {
                this.axios.get(`hronboardings/${item.id}`).then(r => { this.detail = r.data.model; this.detailDialog = true })
            },
            completeTask(t) {
                this.axios.post(`hronboardings-tasks/${t.id}/complete`).then(() => this.openDetail({ id: this.detail.id }))
            },
            statusText(s) { return { open: 'Aperto', completed: 'Completato', cancelled: 'Annullato' }[s] || s },
            statusColor(s) { return { open: 'orange', completed: 'green', cancelled: 'grey' }[s] || 'grey' },
            taskStatusText(s) { return { todo: 'Da fare', doing: 'In corso', done: 'Fatto' }[s] || s },
            taskStatusColor(s) { return { todo: 'grey', doing: 'orange', done: 'green' }[s] || 'grey' },
            roleText(r) { return { hr: 'HR', it: 'IT', manager: 'Manager', employee: 'Dipendente' }[r] || r },
            formatDate(d) { return d ? new Date(d).toLocaleDateString('it-IT') : '—' },
        },

        created() {
            this.$store.commit('endProgress')
            this.load()
        },
    }
</script>
